import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import Home from './pages/Home';
import Listing from './pages/Listing';
import Article from './pages/Article';
import Search from './pages/Search';
import Author from './pages/Author';
import StaticPage from './pages/StaticPage';
import Admin from './pages/Admin';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<Search />} />
          <Route path="/article/:slug" element={<Article />} />
          <Route path="/author/:slug" element={<Author />} />
          <Route path="/about" element={<StaticPage type="about" />} />
          <Route path="/contact" element={<StaticPage type="contact" />} />
          <Route path="/privacy" element={<StaticPage type="privacy" />} />
          <Route path="/terms" element={<StaticPage type="terms" />} />
          <Route
            path="/editorial-policy"
            element={<StaticPage type="editorial-policy" />}
          />
          <Route path="/:section" element={<Listing />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;